import { useRef, useState } from 'react';

export function useAskGXContent() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const historyBtnRef = useRef<HTMLButtonElement | null>(null);

  const handleHistoryClick = () => {
    if (anchorEl) {
      setAnchorEl(null);
    } else if (historyBtnRef.current) {
      setAnchorEl(historyBtnRef.current);
    }
  };

  return {
    anchorEl,
    setAnchorEl,
    historyBtnRef,
    handleHistoryClick
  } as const;
}
